import { render, staticRenderFns } from "./PropertyPicker.vue?vue&type=template&id=1ffba65e&"
import script from "./PropertyPicker.vue?vue&type=script&lang=ts&"
export * from "./PropertyPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports